import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const deleteDenominationChurch = ({ denominationId, churchId }) => {
  return axios.delete(
    `/denominations/${denominationId}/denomination-churches/${churchId}`
  );
};

export const useDeleteDenominationChurch = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeDeleteModal = useCentralStore.getState().closeDeleteModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["denomination-churches"]);
      setNotification({
        type: "success",
        message: "Church deleted successfully!"
      });
      closeDeleteModal();
    },
    ...config,
    mutationFn: deleteDenominationChurch
  });
};
